/**
 * @format
 * @Description: 手工推送消息详情状态机
 * @Autho: 方证
 * @Date: 2019/12/10
 */

import { action, observable, useStrict } from 'mobx';
import Serv from './ManuallyDetailServ';
import Utils from 'utils';
import Cookie from 'js-cookie';
import { message } from 'antd';
import { get, isArray, map } from 'lodash';

const CDN_BASE = 'assets';
useStrict(true);
class ManuallyDetailMod {
  @observable
  form = '';

  @observable
  defaultTime = '';

  @observable
  showModalChooseUser = false;

  @observable
  eventFormData = {};

  @observable
  templateFormData = {};

  @observable
  tabsVal = '3';

  @observable
  tabsData = '';

  @observable
  targetChannels = '';

  @observable
  userData = [];

  @observable
  channelObj = {
  };

  MessageTypeEnum = {
    SMS: '1',
    EMAIL: '2',
    INMAIL: '3',
    WECHAT: '4',
    APP: '5'
  };

  @observable
  listPageUserVersion = 0;

  @action
  updateStore(payload) {
    for (let i in payload) {
      this[i] = payload[i];
    }
  }

  //切换tab
  tabsChange = data => {
    this.updateStore({ tabsVal: data });
    this.tabsChangeAfter();
    this.updateStore({ channelObj: {} });
    this.getChannel();
    this.updateStore({ formVersion: Math.random() });
  };

  getRandom = () => {
    return parseInt((Math.random() + 1) * Math.pow(10, 8 - 1));
  };
  saveFormBeforeRequest = data => {
    //分有没有事件id 有事件id 编辑事件 有模板 绑定模板 没有模板 新增并绑定模板
    //              没有事件id 新增事件 新增模板并绑定给新增的事件
    let sendTime = get(data, ['sendTime', '_d']) ? Utils.timeFormat(get(data, ['sendTime', '_d'])) : '';
    let eventUserDtoList = map(this.userData, item => {
      let obj = {
        email: item.email,
        phone: item.phone,
        status: item.status,
        userId: item.id,
        userName: item.userName
      };
      return obj;
    });
    if (this.eventFormData.id) {
      //编辑事件
      let obj = {
        code: this.eventFormData.code,
        name: data.name,
        sendTime: sendTime || null,
        id: this.eventFormData.id,
        eventUserDtoList: eventUserDtoList
      };
      if (this.templateFormData.id) {
        //编辑事件已有模板
        let random = this.getRandom();
        let messageTemplateReqDto = {
          code: this.templateFormData.code,
          name: this.templateFormData.name,
          id: this.templateFormData.id || undefined,
          msgType: this.tabsVal,
          title: data.title,
          content: data.content,
          providerTplCode: data.providerTplCode,
          jumpUrl: data.jumpUrl
        };
        if (this.tabsVal != 3) {
          messageTemplateReqDto.channelId = data.channelId;
        } else {
          obj.targetChannelList = data.channelId;
        }
        obj.messageTemplateReqDto = messageTemplateReqDto;
        this.updateStore({ eventFormData: obj, templateFormData: messageTemplateReqDto });
      } else {
        let random = this.getRandom();
        //编辑事件 创建新模板并绑定事件
        let templateFormData = {
          code: 'Push_' + random,
          name: 'Push_' + random,
          msgType: this.tabsVal,
          title: data.title,
          content: data.content,
          providerTplCode: data.providerTplCode,
          jumpUrl: data.jumpUrl
        };
        this.updateStore({ templateFormData });
      }
      return obj;
    } else {
      //新增事件
      let random = this.getRandom();
      let obj = {
        code: 'Push_' + random,
        triggerType: 0,
        sendTime: sendTime || null,
        name: data.name,
        eventUserDtoList: eventUserDtoList
      };
      let eventFormData = {};
      for (let i in obj) {
        eventFormData[i] = obj[i];
      }

      let templateFormData = {
        code: 'Push_' + random,
        name: 'Push_' + random,
        msgType: this.tabsVal,
        title: data.title,
        content: data.content,
        providerTplCode: data.providerTplCode,
        jumpUrl: data.jumpUrl
      };

      this.updateStore({ eventFormData, templateFormData });
      return obj;
    }
  };
  saveFormAfterRequest = data => {
    //没有事件id 添加事件id
    if (!this.eventFormData.id) {
      let eventFormData = Object.assign({}, this.eventFormData);
      eventFormData.id = data;
      this.updateStore({ eventFormData });
    }
    //没有模板id 新建模板并绑定事件
    if (!this.templateFormData.id) {
      this.saveTemplateForm({
        eventId: this.eventFormData.id,
        targetChannels: this.targetChannels,
        data: this.templateFormData
      }).then(res => {
        if (res && res.resultCode + '' === '0') {
          message.success(data ? '新建手工推送消息成功' : '编辑手工推送消息成功');
          let templateFormData = Object.assign({}, this.templateFormData);
          templateFormData.id = res.data;
          this.updateStore({ templateFormData });
        } else {
          message.error(res.resultMsg || (data ? '新建手工推送消息失败' : '编辑手工推送消息失败'));
        }
      });
    } else {
      message.success('编辑手工推送消息成功');
    }
  };
  @action saveTemplateForm = async payload => {
    // 请求参数
    let params = payload;

    return await Serv.saveTemplateForm(params);
  };

  @action getListMessageType = async payload => {
    // 请求参数
    let params = payload;

    return await Serv.getListMessageType(params);
  };
  getMessageType = () => {
    this.getListMessageType()
      .then(res => {
        let tabsData = map(res.data.list, item => {
          return {
            key: item.key,
            tab: item.value
          };
        });
        for (let i = 0; i < tabsData.length; i++) {
          if (tabsData[i].tab == '站内信') {
            tabsData.unshift(tabsData[i]);
            tabsData.splice(i + 1, 1);
            break;
          }
        }
        this.updateStore({ tabsData });
      })
      .catch(err => {});
  };
  getUserListBeforeRequest = data => {
    data.phone = data.phone ? data.phone : undefined;
    data.userName = data.userName ? data.userName : undefined;
    return {
      pageSize: data.pageSize,
      pageNum: data.pageNum,
      filter: {
        tenantId: Cookie.get('tenant_id'),
        instanceId: Cookie.get('instance_id'),
        userName: data.userName,
        phone: data.phone
      }
    };
  };
  openChooseUser = data => {
    this.updateStore({ showModalChooseUser: true });
  };
  addUser = data => {
    this.updateStore({ showModalChooseUser: false });
    let userData = this.userData;
    map(data.rows, item => {
      let index = userData.findIndex(item2 => {
        return item2.id == item.id;
      });
      if (index == -1) {
        userData.push(item);
      }
    });
    this.updateStore({ userData: userData, listPageUserVersion: Math.random() });
  };
  delUser = data => {
    let userData = this.userData;
    this.updateStore({ userData: [] });
    map(data.rows, item => {
      let index = userData.findIndex(item2 => {
        return item2.id == item.id;
      });
      if (index != -1) {
        userData.splice(index, 1);
      }
    });
    this.updateStore({ userData });
  };
  @action getListMessageChannel = async payload => {
    // 请求参数
    let params = payload;

    return await Serv.getListMessageChannel(params);
  };
  getChannel = data => {
    let params = {
      pageNum: 1,
      pageSize: 1000,
      tenantId: Cookie.get('tenant_id'),
    };
    this.getListMessageChannel(params).then(res => {
      let channelObj = {
      };
      map(get(res, 'data.list'), item => {
        if (channelObj[item.channelType] && item.status == 1) {
          channelObj[item.channelType].push({ value: item.id, label: item.vender });
        } else {
          channelObj[item.channelType] = [{ value: item.id, label: item.vender }]
        }
      });
      this.updateStore({ channelObj: channelObj });
    });
  };
  changeTargetChannels = data => {
    let str = '';
    if (isArray(data)) {
      map(data, (item, index) => {
        if (index == 0) {
          str = String(item);
        } else {
          str = str + ',' + String(item);
        }
      });
    } else {
      str = data;
    }

    this.updateStore({ targetChannels: str });
  };
  @action getEventById = async payload => {
    // 请求参数
    let params = payload;

    return await Serv.getEventById(params);
  };
  @action getEventUser = async payload => {
    // 请求参数
    let params = payload;

    return await Serv.getEventUser(params);
  };
  getUser = () => {
    if (this.eventFormData.id) {
      this.getEventUser({ id: this.eventFormData.id }).then(res => {
        let userData = res.data.list;
        map(userData, item => {
          item.id = item.userId;
        });
        this.updateStore({ userData });
      });
    }
  };

  tabsChangeAfter = () => {
    this.updateStore({ targetChannels: '', templateFormData: {} });
    let obj = {
      channelId: [],
      code: '',
      title: '',
      content: '',
      providerTplCode: '',
      jumpUrl: '',
      template: '0'
    };
    this.form.setFieldsValue(obj);
    if (this.eventFormData.id) {
      this.getEventById({ id: this.eventFormData.id }).then(res => {
        let list = get(res, 'data.messageTemplateRespDtoList');
        let obj = {
          name: res.data.name
        };
        this.form.setFieldsValue(obj);
        if (res.data.sendTime) {
          let obj = {
            hasTime: '1'
          };
          this.updateStore({ defaultTime: res.data.sendTime });
          this.form.setFieldsValue(obj);
        }
        map(list, item => {
          if (item.msgType == this.tabsVal) {
            let obj = {
              channelId: [],
              title: '',
              content: '',
              providerTplCode: '',
              jumpUrl: ''
            };
            for (let i in obj) {
              obj[i] = item[i];
            }
            obj.name = res.data.name;
            if (this.tabsVal == this.MessageTypeEnum.INMAIL) {
              obj.channelId = res.data.targetChannel;
            }
            this.form.setFieldsValue(obj);
            this.changeTargetChannels(obj.channelId);
            let templateFormData = {
              id: item.id,
              code: item.code,
              name: item.name
            };
            this.updateStore({ templateFormData });
          }
        });
      });
    }
  };
}

// ES6单例写法
export default new ManuallyDetailMod();



// WEBPACK FOOTER //
// ./src/pages/MessageManage/ManuallyDetail/ManuallyDetailMod.js